import { Navigate, useParams } from 'react-router-dom';

import { useGetUnidadesTransporte } from '@/shared/actions/erp/system-settings';
import { LoaderComponent } from '@/shared/components/ui';
import {  SaveUnidadesTransporte} from '../../shared/saveUnidadesTransporte';
import { PermissionsEnum } from '@/auth/interfaces';
import { useCheckPermissions } from '@/shared';

export interface UpdateUnidadesTransportePageInterface {}

const UpdateUnidadesTransportePage: React.FC<UpdateUnidadesTransportePageInterface> = () => {
  useCheckPermissions(PermissionsEnum.api_change_unidadtransporte);

  const { id } = useParams();
  const { data, isLoading } = useGetUnidadesTransporte(id!);

  if (isLoading) return <LoaderComponent />;
  if (!data?.data?.id_unidad_transporte) return <Navigate to="/parametrizacion/unidades-transporte" />;

  return <SaveUnidadesTransporte titlePage="Editar Unidad del transporte" editUnidadesTransporte={data.data} />;
};

export default UpdateUnidadesTransportePage;
